import script from "./LeaderProjectLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderProjectLayout.vue?vue&type=script&setup=true&lang=js"

import "./LeaderProjectLayout.vue?vue&type=style&index=0&id=e5569dce&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5569dce"]])

export default __exports__